import React from 'react';
import PanettoneQuotaZonals from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/QuotaZonals/List.js';

export default function () {
  return <PanettoneQuotaZonals />;
}
